import {connect} from "react-redux";
import {Button, IconButton} from '@mui/material';
import React, {useEffect} from "react";
import i18n from "../../../i18nSetup";
import {Popper} from "@mui/material";
import {ReactComponent as Direction} from "../../assets/Direction.svg";
import Typography from "@mui/material/Typography";
import {findRouteDirections, findPatternsForRoute} from "../../actions/api";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import {rewriteHeadsign, setViewedRoute, resetRouteDirections} from "../../actions/ui";


function ChangeRouteDirection(props) {
  const {tripData, routeDirections, agencyFilter, locale, directionLng} = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  window.onmousedown = function (event) {
    closePopper();
  };

  useEffect(() => {
    if(routeDirections.length > 0 ) {
      setAnchorEl(document.getElementById('btn-change-dir'));
    }
  }, [routeDirections]);

  const openDirectionsList = (event) => {
    event.preventDefault();
    props.findRouteDirections(tripData.motLineId || tripData.route.motLineId || tripData.route?.id, {locale: locale});
  };

  const changeDirections = (event, patternId) => {
    let route = tripData.route;
    let headsign ='';
    props.findPatternsForRoute({routeId: route.id, patternId: patternId}, locale, agencyFilter);
    props.setViewedRoute({ routeId: route.id, pattern: patternId, route, headsign});
    closePopper();
  };

  const originString = (direction) => {

    let result = direction.origin_stop_name || "";
    if(direction.origin_city && !result.toLowerCase().includes(direction.origin_city.toLowerCase())){
      result += ", " + direction.origin_city;
    }
    return result;
  }

  const onMouseDown = (e) => {
    e.stopPropagation();
  };

  const closePopper = (event) => {
    if(anchorEl != null) {
      props.resetRouteDirections();
      setAnchorEl(null);
    }
  };


  const open = Boolean(anchorEl);
  const id = open ? 'change-direction-popper' : undefined;

  return (
    <div>
      <div>
        {
          routeDirections && routeDirections.length > 0 && <Popper placement={'bottom-start'} onMouseDown={onMouseDown} id={id} open={open} anchorEl={anchorEl}>
            <Paper elevation={3}>
              <List component="nav" aria-label="secondary mailbox folders">
                {
                  routeDirections.map((direction, index) => {
                    return (
                      <ListItem button key={index} onClick={(e) => {changeDirections(e, direction.patternId);}}>
                        <ListItemText>
                          <Typography sx={{color: '#000000', fontSize: 14, fontWeight: 300, height: 17}} >
                            {`${originString(direction)} ${directionLng === 'rtl' ? '←' : '→'} ${rewriteHeadsign(direction.headsign)}` + (direction.alternative &&  direction.alternative != '0' && direction.alternative != '#' ? (' (' + direction.alternative + ')') : '')}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                    )
                  })
                }
              </List>
            </Paper>
          </Popper>
        }

      </div>
      <Button id={'btn-change-dir'} size={'small'}  color="primary" startIcon={<Direction sx={{maxWidth: 11, maxHeight: 12}}/>} aria-describedby={id} onClick={(e) => {openDirectionsList(e)}}>
        <Typography sx={{color: '#0000EE', fontSize: 14, fontWeight: 400, textTransform: 'none'}}>{i18n.t('changeDirection')}</Typography>
      </Button>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    routeDirections: state.otp.transitIndex.routeDirections,
    locale: state.otp.currentQuery.locale,
    agencyFilter: state.otp.currentQuery.agencyFilter,
    directionLng: state.otp.config.dir
  }
};

const mapDispatchToProps = {findRouteDirections, findPatternsForRoute, setViewedRoute, resetRouteDirections};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRouteDirection)